import { render, staticRenderFns } from "./backChart.vue?vue&type=template&id=aa022542&"
import script from "./backChart.vue?vue&type=script&lang=js&"
export * from "./backChart.vue?vue&type=script&lang=js&"
import style0 from "./backChart.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports